import { mergeClassnames } from '@heathmont/moon-core-tw';
import Button from '~/client/shared/Button';
import Translate from '~/client/shared/i18n/Translate';
import DepositToPlayBtnVariant1 from './DepositToPlayBtnVariant';
import useDepositToPlay from './hooks/useDepositToPlay';
import useIngameCurrencyRules from '../../../hooks/useIngameCurrencyRules';
import usePlayGame from '../../hooks/usePlayGame';

const PlayButtons: FC = () => {
  const {
    canPlayFunMode,
    handlePlayForReal,
    handlePlayForFun,
    loadingSession,
  } = usePlayGame();
  const { isGameLoadingDisabled } = useIngameCurrencyRules();
  const { isDepositToPlayBtnVisible } = useDepositToPlay();

  return (
    <div
      className={mergeClassnames(
        ' grid grid-flow-col gap-4',
        canPlayFunMode ? 'grid-cols-[1fr_1fr]' : 'grid-cols-[1fr]',
      )}
    >
      {isDepositToPlayBtnVisible && <DepositToPlayBtnVariant1 />}
      {!isDepositToPlayBtnVisible && (
        <Button
          onClick={handlePlayForReal}
          animation={loadingSession ? 'progress' : undefined}
          disabled={loadingSession || isGameLoadingDisabled}
        >
          <Translate id="game.play_for_real" />
        </Button>
      )}
      {canPlayFunMode && (
        <Button
          variant="secondary"
          onClick={handlePlayForFun}
          disabled={loadingSession}
          animation={loadingSession ? 'progress' : undefined}
        >
          <Translate id="game.fun_mode" />
        </Button>
      )}
    </div>
  );
};

export default PlayButtons;
